import { useEffect } from "react";

/**
 * Lightweight SEO helper - updates document.title and meta description per route.
 * No external dependency. Server-side rendering for crawlers is handled by
 * the static <head> of index.html (which already contains the homepage values
 * and structured data).
 */
export default function Seo({ title, description, canonical }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", description);

      // Mirror to og:description for social sharing snapshots
      let og = document.querySelector('meta[property="og:description"]');
      if (og) og.setAttribute("content", description);
    }

    if (title) {
      let og = document.querySelector('meta[property="og:title"]');
      if (og) og.setAttribute("content", title);
    }

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);

      let ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) ogUrl.setAttribute("content", canonical);
    }
  }, [title, description, canonical]);

  return null;
}
